import React, { useState, useEffect } from "react";
import './CardSearch.css';
import { fetchCardsByName } from "../logic/CardSearchLogic";
import { useNavigate } from 'react-router-dom';
import ymeLogo from '../assets/icons/yme.png';
import { playSound } from '../utils/soundPlayer';
import { useTranslation } from 'react-i18next'; // ✅ Add this

const CardSearch = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [cards, setCards] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);
  const navigate = useNavigate();
  const { t } = useTranslation(); // ✅ Add this

  useEffect(() => {
    document.body.style.overflow = selectedCard ? 'hidden' : 'auto';
    return () => { document.body.style.overflow = 'auto'; };
  }, [selectedCard]);


  const handleSearch = async () => {
    const results = await fetchCardsByName(searchTerm);
    setCards(results);
  };

  return (
    <div className="card-search-container">
      <img
        onContextMenu={(e) => e.preventDefault()}
        onMouseDown={(e) => e.button === 2 && e.preventDefault()}
        onTouchStart={(e) => e.preventDefault()}
        draggable={false}
        src={ymeLogo} alt="YME Logo" className="background-logo" />
      <h2 className="card-search-title">{t('cardSearch.title')}</h2>
      <p className="titleText">{t('cardSearch.subtitle')}</p>

      <div className="search-wrapper">
        <button className="back-button" onClick={() => {
          playSound('return');
          navigate('/tool');
        }}>
          {t('cardSearch.back')}
        </button>

        <div className="search-bar">
          <input
            type="text"
            placeholder="Enter card name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button onClick={handleSearch}>{t('cardSearch.search')}</button>
        </div>
      </div>

      <div className="card-results-tool">
        {cards.map((card) => (
          <div key={card.id} className="search-card" onClick={() => setSelectedCard(card)}>
            <div className="card-info-img-general">
              <img
                src={card.card_images[0].image_url_small}
                alt={card.name}
                className="search-card-image"
                onContextMenu={(e) => e.preventDefault()}
                onMouseDown={(e) => e.button === 2 && e.preventDefault()}
                onTouchStart={(e) => e.preventDefault()}
                draggable={false}
              />

              <div className="card-info-general">
                <div><strong>Name:</strong> {card.name}</div>
                {card.attribute && <div><strong>Attribute:</strong> {card.attribute}</div>}
                {card.race && <div><strong>Type:</strong> {card.race}</div>}
                {(card.level || card.rank || card.linkval) && (
                  <div>
                    <strong>{card.linkval ? 'Link Rating' : card.rank ? 'Rank' : 'Level'}:</strong>{' '}
                    {card.linkval || card.rank || card.level}
                  </div>
                )}
                {card.scale !== undefined && (
                  <div><strong>Pendulum Scale:</strong> {card.scale}</div>
                )}
                {(card.atk !== undefined || card.def !== undefined) && (
                  <div>
                    <strong>ATK/DEF:</strong> {card.atk !== undefined ? card.atk : '-'} /
                    {card.def !== undefined ? ` ${card.def}` : ' -'}
                  </div>
                )}
              </div>
            </div>

            <p className="searchpage-card-desc">
              {
                card.desc
                  ?.replace(/(?=●|\[.*?\])/g, '\n')
                  .replace(/\\n/g, '\n')
              }
            </p>
          </div>
        ))}
      </div>


      {selectedCard && (
        <div className="card-modal" onClick={() => setSelectedCard(null)}>
          <div className="card-modal-content" onClick={(e) => e.stopPropagation()}>
            <img
              onContextMenu={(e) => e.preventDefault()}
              onMouseDown={(e) => e.button === 2 && e.preventDefault()}
              onTouchStart={(e) => e.preventDefault()}
              draggable={false}
              src={selectedCard.card_images[0].image_url} alt={selectedCard.name} />
            <h3>{selectedCard.name}</h3>
            <p dangerouslySetInnerHTML={{
              __html: selectedCard.desc
                .split(/(\[.*? Effect \])/g)
                .map((part, index) =>
                  part.match(/\[.*? Effect \]/)
                    ? `<br /><strong>${part}</strong><br />`
                    : part
                      .replace(/(\d+)/g, '<span class="highlight-number">$1</span>')
                      .replace(/\(Quick Effect\)/g, '<span class="highlight-quick">(Quick Effect)</span>')
                      .replace(/;/g, '<span class="highlight-semicolon">;</span>')
                      .replace(/●/g, '<br /><span class="effect-dot">●</span>')
                )
                .join('')
            }} />
            <button onClick={() => setSelectedCard(null)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CardSearch;
